module.exports = "<div class=\"row text-center\" style=\"margin: 10% auto;\">\r\n  <h3>Validation Successful</h3>\r\n  <p class=\"lead\">You have successfully validated your email, please <a class=\"red\" href=\"/login\">login</a>.</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/email-success/email-success.component.html
// module id = ../../../../../src/app/component/email-success/email-success.component.html
// module chunks = main